/**
 * Coach Tools group-event templates embed editor-only blocks and placeholders.
 * Strip them before plain-text snippets (profile offering cards, More events, etc.).
 */
const COACH_INSTRUCTIONS_BLOCK = /\[(?:<{2,3}|\[{1,2}<{1,2})COACH INSTRUCTIONS[\s\S]*?(?:>>>\]|>{2,3}\])/gi
const INSERT_PLACEHOLDER = /\*{0,2}\[<{2,3}Insert[\s\S]*?>>>\]\*{0,2}/gi

const stripGroupEventCoachBoilerplate = (value) => {
  if (value == null || value === '') return value
  return String(value)
    .replace(COACH_INSTRUCTIONS_BLOCK, '')
    .replace(INSERT_PLACEHOLDER, '')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

export default stripGroupEventCoachBoilerplate
